/** Load JOIN only when its section is visible, after the above-the-fold image has loaded. */
(() => {
  if (customElements.get('deferred-stories')) return;
  customElements.define('deferred-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.observer?.disconnect();
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async load() {
      if (this.started) return;
      this.started = true;
      const hero = document.querySelector('slideshow-carousel .is-selected img, .product-gallery__media img[loading="eager"]');
      if (hero && !hero.complete) {
        await new Promise(resolve => {
          const done = () => {
            hero.removeEventListener('load', done);
            hero.removeEventListener('error', done);
            resolve();
          };
          hero.addEventListener('load', done, { once: true });
          hero.addEventListener('error', done, { once: true });
        });
      }
      // Give the browser a paint opportunity before starting the third-party widget.
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!this.isConnected) { this.started = false; return; }
        const template = this.querySelector('template');
        if (!template) return;
        for (const original of template.content.querySelectorAll('script')) {
          const script = document.createElement('script');
          for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
          script.async = false;
          script.textContent = original.textContent;
          this.appendChild(script);
        }
        template.remove();
      }));
    }
  });
})();
